export enum MemberOrderType {
    Wholesale = 'Wholesale',
    Retail = 'Retail',
    Personal = 'personal',
    Enrollment = 'enrollment'
}



// WEBPACK FOOTER //
// ./src/app/customerservice/enums/member-order-type.enum.ts